import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import CatalogColorsList from './CatalogColorsList'
import CatalogRequestForm from './CatalogRequestForm'
import { useCatalogue } from "../components/context/CatalogueWrapper";
import { toast } from 'react-hot-toast'
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { loggedProfile } from '../redux/actions/userActions';

const CatalogRequest = () => {

  const dispatch = useDispatch();
  const { selectedCatalogues: selectedColorCards } = useCatalogue();

  const userLogin = useSelector(state => state.userLogin)
  const { userDetails } = userLogin

  const userProfile = useSelector(state => state.userProfile)
  const { profile } = userProfile

  const navigate = useNavigate();

  const initialState = {
    phone: "",
    delivery_address: "",
    zip: "",
    city: "",
    country: "",
    orderRows: [],
    user_comment: "",
  };

  const [values, setValues] = useState(initialState);


  useEffect(() => {
    dispatch(loggedProfile())
    setValues(initialState);
  }, [])


  const handleSubmit = (values) => {

    const formData = new FormData();

    if (Object.keys(selectedColorCards).length > 0) {

      for (var i = 0; i < selectedColorCards.length; i++) {
        formData.append('orderRows[]', selectedColorCards[i]);
      }
      formData.append('phone', values.phone)
      formData.append('delivery_address', values.delivery_address)
      formData.append('zip', values.zip)
      formData.append('city', values.city)
      formData.append('country', values.country)
      formData.append('user_comment', values.user_comment)

      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + '<---- key | value ----> ' + pair[1]);
      // }

    } else {
      toast.error(<FormattedMessage id="app.general.selectOneColor" defaultMessage="Select at least one color card" />)
      return
    }

    try {
      const headers = {
        headers: {
          "x-auth-token": userDetails.token,
        }
      };
      const data = axios.post(process.env.REACT_APP_API_ENDPOINT + `/orders`, formData, headers)
      data.then(res => {
        if (res['data'].status === "ok") {
          setTimeout(() => navigate(0), 2000)
          // toast.success(<FormattedMessage id="app.general.orderCreated" defaultMessage="Sample request sent" />)
          //TODO:: empy context
          navigate('/app/catalog');

        } else {
          toast.error('errore nei dati')
        }
      })
    } catch (error) {
      toast.error(error)
    }

  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };



  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <CatalogColorsList />
        <CatalogRequestForm
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          values={values}
        />
      </div>
    </>
  )
}

export default CatalogRequest